import { IconButton, Tooltip } from "@material-ui/core"
import React, { useState } from "react"
import { ArticleStatus } from "../../../types/article"
import { httpRequest } from "../../../utils/common-utils"
import { ADMIN, EDITOR, MANAGER, PRODUCER } from "../../../utils/roles"
import Auth from "../../Auth"
import ConfirmationDialog from "../../commons/ConfirmationDialog"
import { RePublishIcon } from "../../commons/icon/icons"
import { fetchArticle } from "../../../redux/actions/article/article.actions"
import { useDispatch } from "react-redux"

type Props = {
    articleId: string,
    status: ArticleStatus,
    bundleId?: string,
    periodicalId: string,
    size?: 'small' | 'medium',
    className?: any,
    isButton?: boolean,
    refreshDate?: boolean,
    onSuccess?: () => void
}

const RePublishDialog = ({ isOpen, close, onValidate }: { isOpen: boolean, close: () => void, onValidate: () => void }) => {


    return (
        <ConfirmationDialog
            title="Confirmez-vous la mise en ligne du document ?"
            description=""
            actions={[
                {
                    label: 'Oui',
                    action: onValidate,
                    variant: 'contained'
                },
                {
                    label: 'Non', action: close,
                    close: false,
                    color: 'default'
                },
            ]}
            isOpened={isOpen}
            onClose={close}
        />
    )
}

export const RePublishButton = ({ articleId, periodicalId, bundleId: bundle, status, size, className, isButton, refreshDate = false, onSuccess }: Props) => {
    const TOOLTIP_INFO = "Relivrer pour réindexation"
    const BELONG_TO_ONE_OR_MORE_BUNDLE = bundle !== undefined && bundle !== null
    const IS_NOT_ALLREADY_PUBLISHED = status !== ArticleStatus.PUBLISHED
    const dispatch = useDispatch()

    const [isOpen, setIsOpen] = useState(false)

    const onValidate = async () => {
        await httpRequest({ url: `${window.location.origin}/api/article/re-publish`, method: 'POST', data: { articleId, periodicalId } })
        setIsOpen(false)
        if(refreshDate) {
            dispatch(fetchArticle(articleId))
        }
        onSuccess?.()
    }

    if (BELONG_TO_ONE_OR_MORE_BUNDLE || IS_NOT_ALLREADY_PUBLISHED) return <></>

    return (
        <Auth requiredRoles={[ADMIN, MANAGER, EDITOR, PRODUCER]} periodicalRestriction={periodicalId}>
            <RePublishDialog isOpen={isOpen} close={() => setIsOpen(false)} onValidate={onValidate} />
            <Tooltip
                title={TOOLTIP_INFO}>
                <IconButton
                    onClick={() => { setIsOpen(true) }}>
                    <RePublishIcon />
                </IconButton>
            </Tooltip>

        </Auth>
    )
}